import React from 'react';
import { Tweet } from 'react-twitter-widgets'

export default function TwitterTweet({ cmpProps, style }) {
    let { tweetId } = cmpProps;
    return <Tweet style={style} tweetId={tweetId} />
}